import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { pathOr } from "ramda";
import { shoes } from "@/data/content";
import SectionMoreProducts from "./SectionMoreProducts";
import SectionNavigation from "./SectionNavigation";
import SectionProductHeader from "./SectionProductHeader";
import SectionProductInfo from "./SectionProductInfo";

const getProductData = async (id: string) => {
  return shoes.find((item) => item.slug === id);
};

const SingleProductPage = () => {
  const { slug } = useParams<{ slug: string }>();
  const [product, setProduct] = useState<any>(null);

  useEffect(() => {
    if (slug) {
      getProductData(slug).then((data) => setProduct(data));
    }
  }, [slug]);

  if (!product) return <div>Loading...</div>;

  return (
    <div className="container">
      <SectionNavigation />

      <div className="mb-20">
        <SectionProductHeader
          shots={pathOr([], ["shots"], product)}
          shoeName={pathOr("", ["shoeName"], product)}
          prevPrice={pathOr(0, ["previousPrice"], product)}
          currentPrice={pathOr(0, ["currentPrice"], product)}
          rating={pathOr(0, ["rating"], product)}
          pieces_sold={pathOr(0, ["pieces_sold"], product)}
          reviews={pathOr(0, ["reviews"], product)}
        />
      </div>

      <div className="mb-28">
        <SectionProductInfo
          overview={pathOr("", ["overview"], product)}
          shipment_details={pathOr([], ["shipment_details"], product)}
          ratings={pathOr(0, ["rating"], product)}
          reviews={pathOr(0, ["reviews"], product)}
        />
      </div>

      <div className="mb-28">
        <SectionMoreProducts />
      </div>
    </div>
  );
};

export default SingleProductPage;
